<script lang="ts">
    // import TibiPageBuilder from "../TibiPageBuilder/TibiPageBuilder.svelte"
    import ContentBuilder from "../widgets/ContentBuilder.svelte"
    import Header from "../widgets/Header.svelte"

    export let content: Content
</script>

<Header type="{1}" />

{#if content}
    <main class="page {content?.type?.join(' ').toLowerCase()}">
        <section class="wm-container">
            <!-- <TibiPageBuilder content="{content}" /> -->
            <ContentBuilder content="{content.pageBuilder}" />
        </section>
    </main>
{/if}
